import React, { useEffect } from "react";
import { useNotifications } from "../context/NotificationContext";
import { Bell, Check, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";

export default function Notifications() {
  const { notifications, unreadCount, markAllAsRead } = useNotifications();

  useEffect(() => {
    if (unreadCount > 0) {
      markAllAsRead();
    }
  }, [unreadCount, markAllAsRead]);

  return (
    <div className="space-y-6">
      <div className="flex items-end justify-between">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">Benachrichtigungen</h1>
          <p className="text-white/50 text-sm mt-1">Deine aktuellen Ereignisse und Updates.</p>
        </div>
        {notifications.length > 0 && (
          <button
            onClick={markAllAsRead}
            className="text-xs text-white/50 hover:text-white flex items-center gap-1.5 transition-colors"
          >
            <Check className="w-3.5 h-3.5" /> Alle als gelesen markieren
          </button>
        )}
      </div>

      <div className="bg-white/5 border border-white/10 rounded-sm">
        {notifications.length === 0 ? (
          <div className="p-12 text-center text-white/40 flex flex-col items-center">
            <Bell className="w-8 h-8 mb-3 opacity-20" />
            <p>Du hast keine neuen Benachrichtigungen.</p>
          </div>
        ) : (
          <div className="divide-y divide-white/10">
            {notifications.map((n) => (
              <div
                key={n.id}
                className={`p-4 flex gap-4 items-start transition-colors ${
                  n.read ? "opacity-60" : "bg-primary/5"
                }`}
              >
                <div
                  className={`mt-1 flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center ${
                    n.read ? "bg-white/10 text-white/50" : "bg-primary/20 text-primary"
                  }`}
                >
                  <Bell className="w-4 h-4" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex justify-between items-start gap-4">
                    <h4 className="text-sm font-medium text-white truncate">{n.title}</h4>
                    <span className="text-xs text-white/40 whitespace-nowrap">
                      {new Date(n.created_at).toLocaleDateString("de-DE", {
                        day: "2-digit",
                        month: "2-digit",
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </span>
                  </div>
                  <p className="text-sm text-white/70 mt-1">{n.message}</p>
                  {n.link && (
                    <Link
                      to={n.link}
                      className="inline-flex items-center gap-1 text-xs text-primary mt-2 hover:underline"
                    >
                      Ansehen <ExternalLink className="w-3 h-3" />
                    </Link>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
